import templateUrl from "./layout-shell.html"
export const LayoutShellComponent = {
    bindings: {
        showSidebar: "<"
    },
    transclude: {
        body: "apexBodyContent",
        sidebar: "apexSidebarContent"
    },
    replace: true,
    templateUrl,
    controller: class CollapsibleSidebar {
        constructor($transitions, $window, apexDeployStage) {
            'ngInject';
            this.$transitions = $transitions;
            this.$window = $window;
            this.apexDeployStage = apexDeployStage;
        }
        $onInit() {
            // Auto-expand sidebar if the window size is initially greater than xs

            const isDesktopBreakpoint = this.$window.outerWidth > 767;
            if (isDesktopBreakpoint) {
                this.expanded = (localStorage.getItem("collapsibleSidebarExpanded") || "true") === "true"
            }

            // Register transitions handlers so that the menu can be closed after clicking a link.
            this.$transitions.onSuccess({}, () => {
                if (!isDesktopBreakpoint) {
                    this.expanded = false;
                }
            })
        }

        toggleExpanded() {
            this.expanded = !this.expanded
            localStorage.setItem("collapsibleSidebarExpanded", this.expanded);
        }
    }
}
